// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2WMyr","addWidgetButton":"Header_addWidgetButton__VkRBR","dashboardTabs":"Header_dashboardTabs__2ZetD","active":"Header_active__3Wdtq"};